export const casesHero = {
  eyebrow: '客户案例',
  title: '项目索引与客户覆盖',
  titleHighlight: '已确认 · 已验证 · 可核验',
  subtitle: '展示华辉数智及九畴云市的项目列表与客户覆盖范围。',
  desc: '所有案例数据、客户名称、合作关系与效果指标均使用已确认信息，不虚构结果；标注为规划或推进中的内容，不代表已实现成果。',
};

export interface CaseItem {
  id: string;
  name: string;
  region: string;
  industry: string;
  type: string;
  scene: string;
  problem: string;
  solution: string;
  status: '已验证' | '推进中' | '待授权';
  date: string;
  href: string;
}

export const cases: CaseItem[] = [
  {
    id: 'CASE-001',
    name: '帝星数商综合体',
    region: '中国 · 北京',
    industry: '数字商业 · 消费',
    type: '城市验证 · 0# 首发',
    scene: '会员、门店、消费卡与数字经营',
    problem: '存量会员缺乏数字经营入口，门店与消费数据割裂，复购与传播难。',
    solution: '数字货架 + 消费卡 + TOMA 智能体 + 云创客协同',
    status: '已验证',
    date: '2026.08',
    href: '/launch',
  },
  {
    id: 'CASE-002',
    name: '大庄科样板间',
    region: '中国 · 北京 · 延庆',
    industry: '乡村数字经济',
    type: '乡村复制 · 1# 样板',
    scene: '农产品上行与县域网络复制',
    problem: '农产品销售难、信息不对称，乡村小店缺流量与资金。',
    solution: 'ePin 溯源 + 数字货架 + 信用进货 + 云社员协同',
    status: '已验证',
    date: '2026.08',
    href: '/scale',
  },
  {
    id: 'CASE-003',
    name: '帝星咖啡',
    region: '中国 · 北京',
    industry: '消费 · 餐饮',
    type: '消费场景 · 数字权益',
    scene: '数字消费与权益运营验证',
    problem: '餐饮消费缺少数字权益与社交场景，复购与传播难。',
    solution: '云厨菜单 + 数字消费权益 + 核销',
    status: '推进中',
    date: '2026.08',
    href: '/cases',
  },
  {
    id: 'CASE-004',
    name: '京客隆云厨场景',
    region: '中国 · 北京',
    industry: '零售 · 云厨',
    type: '场景验证',
    scene: '云厨菜单与消费场景',
    problem: '待授权公开，合作细节以正式公告为准。',
    solution: '授权后公开',
    status: '待授权',
    date: '—',
    href: '#',
  },
  {
    id: 'CASE-005',
    name: '敬龙国际「味聚」项目',
    region: '中国 · 北京',
    industry: '餐饮消费 · 供应链',
    type: '消费场景 · 餐饮平台',
    scene: '聚餐社交、餐饮经营、甄选商城与供应链协同',
    problem: '消费者组局与权益分散，商家经营割裂，供应链协同与履约溯源缺乏统一平台。',
    solution: '聚餐社交 + 餐饮经营工作台 + 甄选商城 + 供应链协同 + 数字权益 + 平台治理',
    status: '推进中',
    date: '2026.08',
    href: '/weiju',
  },
  {
    id: 'CASE-006',
    name: '铼停科技自由流停车',
    region: '中国 · 城市停车运营场景',
    industry: '自由流停车 · 交通',
    type: '智慧交通 · 停车运营',
    scene: '车场物联、统一运营与停车数据分析',
    problem: '多品牌设备接口不统一、多场库分散管理，收费与对账流程繁琐，通行体验待提升。',
    solution: '停车物联 + 统一运营平台 + 车位引导 + 无感支付 + 边缘计算 + 数据分析',
    status: '推进中',
    date: '2026.08',
    href: '/cases/lieting-smart-parking',
  },
  {
    id: 'CASE-007',
    name: '中仙数智商贸',
    region: '县域 · 农贸流通场景',
    industry: '农业 · 农产品流通',
    type: '县域 · 农贸流通',
    scene: '农产品数字化上行与品质追溯',
    problem: '农产品来源与品质难证明，产销两端信息不对称，优质农产品难以获得应有的市场回报。',
    solution: 'ePin 一物一码溯源 + 数字货架上行 + 批次品质档案 + 产销数据协同',
    status: '推进中',
    date: '2026.08',
    href: '/cases/zhongxian-farm-market',
  },
];

export const caseTypes = ['全部类型', '城市验证', '乡村复制', '消费场景', '场景验证'];
export const caseStatuses = ['全部状态', '已验证', '推进中', '待授权'];